// A single entry in the Errors array returned by the
// accounting-journal/.../calculate endpoint.
type UnresolvedLedgerAccountError = {
    Kind:string;
    SourceEntityName:string;
    SourceEntityID:string;
    SourceKeyPath:string;
    Reason?:string;
};

// Resolved row data backing a single cell in the table.
type UnresolvedLedgerAccountTarget = {
    error:UnresolvedLedgerAccountError;
    targetEntity:MIOManagedObject;
    targetField:string;
    targetLabel:string;
    chosenAccount:LedgerAccount;
};

class UnresolvedLedgerAccountErrorsViewController extends MUIViewController
{
    static newInstance() : UnresolvedLedgerAccountErrorsViewController {
        let vc = new UnresolvedLedgerAccountErrorsViewController("unresolved-ledger-account-errors-view");
        vc.initWithResource("layout/accounting_entries/UnresolvedLedgerAccountErrorsView.html");
        return vc;
    }

    get preferredContentSize(){
        return new MIOSize(900, 500);
    }

    private tableView:UITableView = null;
    private saveRetryButton:MUIButton = null;
    private cancelButton:MUIButton = null;

    private _targets:UnresolvedLedgerAccountTarget[] = [];
    private _retryTarget:any = null;
    private _retryCallback:any = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        if (this.tableView) {
            this.tableView.dataSource = this;
            this.tableView.delegate = this as any;
        }

        this.cancelButton = MUIOutlet(this, "cancel-btn", "MUIButton");
        if (this.cancelButton) this.cancelButton.setAction(this, function(this:UnresolvedLedgerAccountErrorsViewController){
            this.dismissViewController(true);
        });

        this.saveRetryButton = MUIOutlet(this, "save-retry-btn", "MUIButton");
        if (this.saveRetryButton) this.saveRetryButton.setAction(this, this.saveAndRetry);
    }

    viewWillAppear(animated?) {
        super.viewWillAppear(animated);
        this.updateUI();
    }

    setErrors( item:any, errors:UnresolvedLedgerAccountError[], target:any, retry:any ) {
        this._retryTarget = target;
        this._retryCallback = retry;
        this._targets = [];

        let unresolved = (errors ?? []).filter( e => e != null && e.Kind == "unresolvedLedgerAccount" );
        for (let i = 0; i < unresolved.length; i++) {
            let t = this.buildTarget( item, unresolved[i] );
            if (t != null) this._targets.push( t );
        }
        this.updateUI();
    }

    private updateUI() {
        if (this.viewIsLoaded == false) return;
        this.tableView.reloadData();
    }

    private resolveSource( item:any, error:UnresolvedLedgerAccountError ):MIOManagedObject {
        if (item == null) return null;
        if (item.identifier == error.SourceEntityID) return item;
        let lines = item.valueForKey ? item.valueForKey( "lines" ) : [];
        for (let i = 0; i < lines.count; i++) {
            let ln = lines.objectAtIndex(i)
            if (ln != null && ln.identifier == error.SourceEntityID) return ln;
        }        
        return null;
    }

    private buildTarget( item:any, error:UnresolvedLedgerAccountError ):UnresolvedLedgerAccountTarget {
        let source = this.resolveSource( item, error );
        if (source == null) return null;

        let parts = (error.SourceKeyPath ?? "").split(".");
        if (parts.length < 1) return null;

        let field = parts[parts.length - 1];
        let parentPath = parts.slice(0, parts.length - 1).join(".");
        let target = parentPath.length > 0
            ? source.valueForKeyPath( parentPath ) as MIOManagedObject
            : source;
        if (target == null) return null;

        let name = (target as any).name ?? (target as any).title ?? (target as any).identifier;
        return {
            error: error,
            targetEntity: target,
            targetField: field,
            targetLabel: name,
            chosenAccount: null
        };
    }

    numberOfSections( tableview:UITableView ) { return 1; }
    numberOfRowsInSection( tableview:UITableView, section:number ) { return this._targets.length; }

    cellAtIndexPath( tableview:UITableView, indexPath:MIOIndexPath ) {
        let cell = tableview.dequeueReusableCellWithIdentifier( "UnresolvedLedgerAccountErrorCell" ) as UnresolvedLedgerAccountErrorCell;
        cell.target = this._targets[ indexPath.row ];
        return cell;
    }

    private saveAndRetry() {
        for (let i = 0; i < this._targets.length; i++) {
            let t = this._targets[i];
            if (t.targetEntity != null && t.targetField != null && t.chosenAccount != null) {
                t.targetEntity.setValueForKey( t.chosenAccount, t.targetField );
            }
        }
        DBHelper.saveMainContext();

        let target = this._retryTarget;
        let cb = this._retryCallback;
        this.dismissViewController(true);
        if (cb != null && target != null) cb.call( target );
    }
}
